export enum FileType {
    Pdf = 'pdf',
    Excel = 'excel',
    Word = 'word'
}
